import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {deleteActiveGenderSort, setActiveGenderSort} from "../../helpers/product";
import { isMobileOnly} from "react-device-detect";
import qs from "query-string";
import {useTranslation} from "react-i18next";

const ShopGender = ({ location, currentQuery, setCurrentQuery, genders, getSortParams, isHome, setLoadingProducts }) => {
  const [isSmallScreen, setSmallScreen] = useState(false);
    const { t } = useTranslation()

  const query = qs.parse(location.search, {
      ignoreQueryPrefix: true
  });
  const filterButtons = document.querySelectorAll(
      ".sidebar-widget-tag-gender button"
  );

    filterButtons.forEach(item => {
        item.classList.remove("active");
    });

    if (query && query.genders) {
        let genders = query.genders.split('_');
        genders.map(size => {
            var element = document.getElementById("gender_"+size);
            if (element){
                element.classList.add("active")
            }
        })
    }

    useEffect(() => {
        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        }
    }, [])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(false)
        }
    })

    function constructAddQueryPath(query, size) {
        if (query && query.genders) {
            return query.genders + "_" + size
        }
        return size
    }

  return (
    <div className="sidebar-widget mt-10">
        {
            isMobileOnly || isSmallScreen ?
                <div>
                    <h4 className="pro-sidebar-title">{isHome ? "Quel est son sexe ?" : "Sexe :"}</h4>
                    <div className="sidebar-widget-tag-gender mt-10" style={{display: 'block'}}>
                        {genders ? (
                            <ul>
                                {genders.map((gender, key) => {
                                    return (
                                        <li key={"gender_"+key}>
                                            <button
                                                className="toto"
                                                id={"gender_"+gender}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("gender", "");
                                                        setCurrentQuery({ ...currentQuery, genders: ""});
                                                        deleteActiveGenderSort(e);
                                                    } else {
                                                        getSortParams("gender", gender);
                                                        setCurrentQuery({ ...currentQuery, genders: gender});
                                                        setActiveGenderSort(e);
                                                    }
                                                }}
                                            >
                                                {t(gender.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
                :
                <div>
                    <h4 className="pro-sidebar-title">{isHome ? "Quel est son sexe ?" : "Sexe :"}</h4>
                    <div className="sidebar-widget-tag-gender mt-10">
                        {genders ? (
                            <ul>
                                {genders.map((gender, key) => {
                                    return (
                                        <li key={"gender_"+key}>
                                            <button
                                                className="toto"
                                                id={"gender_"+gender}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("gender", "");
                                                        setCurrentQuery({ ...currentQuery, genders: ""});
                                                        deleteActiveGenderSort(e);
                                                    } else {
                                                        getSortParams("gender", gender);
                                                        setCurrentQuery({ ...currentQuery, genders: gender});
                                                        setActiveGenderSort(e);
                                                    }
                                                }}
                                            >
                                                {t(gender.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
        }
    </div>
  );
};

export function getLabel(gender, t){
    switch (gender){
        case "Women":
            return t('gender')
        case "Men":
            return "Homme"
        case "Unisex":
            return "Non Genré"
        default:
            return
    }
}

export function ConstructRemoveGenderQueryPath(query, sizeToRemove) {
    if (query && query.genders) {
        let genders = query.genders.split('_');
        genders = genders.filter(size => {
            return size !== sizeToRemove;
        })
        if (genders.length > 0) {
            let newSizeQuery = ""
            genders.map((size, index) => {
                if (index == 0){
                    newSizeQuery += size
                } else {
                    newSizeQuery +=  "_" + size
                }
            })
            return newSizeQuery
        } else {
            return null
        }

    }
    return null
}

ShopGender.propTypes = {
  getSortParams: PropTypes.func,
  tags: PropTypes.array,
  currentQuery: PropTypes.object,
  setCurrentQuery: PropTypes.func,
    location: PropTypes.string
};

export default ShopGender;
